/**
 * @typedef {Object} valoresAlcada
 * @property {number} percentual_corretor
 * @property {number} meses_corretor
 * @property {number} percentual_gerente
 * @property {number} meses_gerente
 */

import React, { useState, useEffect } from 'react';
import { default as Selector } from 'react-select';
import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import _isEmpty from 'lodash/isEmpty';
import {
  IoIosAddCircleOutline,
  IoIosRemoveCircleOutline,
} from 'react-icons/io';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  FaRegEdit,
  FaRegWindowClose,
  FaPlus,
  FaTrash,
  FaCheckCircle,
  FaTimesCircle,
  FaRegEye,
} from 'react-icons/fa';

import { Container } from './styles';
import ModalSinal from '../ModalSinal';
import ModalFormaPgto from '../ModalFormaPgto';
import ModalDivisaoComissao from '../ModalDivisaoComissao';
import SendToClipboardButton from '~/Components/SendToClipboardButton';

import { createDate, getToday } from '~/Utils/Helpers';
import { format, formatarMonetario } from '~/Utils/Helpers.js';
import dialog from '~/Utils/dialog';
import {
  FORMAS_PAGAMENTO_BY_CODIGO,
  BOLETO,
  CARTAO,
  DEPOSITO,
  DINHEIRO,
  CHEQUE,
  DIAS_TOLERANCIA_VENCIMENTO_CHEQUE_DEPOSITO,
  DATE_FORMAT_SERVER,
  SEGUNDO_EMPREENDIMENTO_LANCAMENTO,
  EMPREENDIMENTO_LANCAMENTO,
  CondicoesEspeciaisStatus,
} from '~/constant';
import ConfirmButton from '~/Components/ConfirmButton';
import Hint from '~/Components/Hint/Hint';
import {
  calcularTotalEntradaAVista,
  calcularDataVencimentoMinimaBoleto,
  calcularValorSinalEsperado,
} from '~/Pages/Vendas/helpers';
import ModalDataVencimento from '../ModalDataVencimento';
import * as api from '~/Services/Service';
import {
  selecionaConstrutor,
  setCondicoesEspeciais,
  setVendaInterna,
  setTravarVenda,
} from '~/Store/Vendas/actions';
import { useDispatch } from 'react-redux';
import ModalCondicoesEspeciais from '../CondicoesEspeciais/ModalCondicoesEspeciais';
import AuthStorage from '~/Utils/AuthStorage';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { TipoComissao } from '~/constant';
import { customStyles } from '~/Styles/reactSelectStyles';

export default function FormularioSinal({
  empreendimento,
  selecionaTabela,
  tabelaSelecionada,
  tabelasPorCodigo,
  selecionaAtivo,
  ativosSelecionados,
  ativosDaTabelaSelecionadaPorCodigo,
  salvarSinal,
  salvarDivisaoComissao,
  listaFormasDePagamento,
  listaFormasDePagamentoImob,
  totalEntrada,
  totalEntradaIncorporadora,
  totalFaltanteEntrada,
  totalFaltanteEntradaIncorporadora,
  totalTitulosSinal,
  totalTituloSinalIncorp,
  adicionaFormaPgtoEntrada,
  removeTodasParcelasEntrada,
  removeFormaPgtoEntrada,
  atualizaFormaPgtoEntrada,
  adicionaFormaPgtoEntradaImob,
  removeTodasParcelasEntradaImob,
  removeFormaPgtoEntradaImob,
  atualizaFormaPgtoEntradaImob,
  readonly,
  corretores,
  divisaoComissao,
  cartoes,
  dataVenda,
  setDataVenda,
  codigoFamilia,
  condicoesEspeciaisObj,
  prospecto,
}) {
  const dataVencimentoMinima = calcularDataVencimentoMinimaBoleto(
    empreendimento
  );
  const isCorretorSetpar = AuthStorage.getUser().usuario === 1078;
  const dispatch = useDispatch();

  const FORMA_PGTO_INICIAL = {
    tipo_parcela: '',
    [BOLETO]: {
      qtdParcelas: '1',
      valor: '',
      vencimento: '',
      vencimento_mask: dataVencimentoMinima
        ? format.date(dataVencimentoMinima)
        : '',
    },
    [DINHEIRO]: {
      valor: '',
      vencimento: '',
      vencimento_mask: format.date(getToday()),
    },
    [DEPOSITO]: {
      valor: '',
      vencimento: '',
      vencimento_mask: format.date(getToday()),
    },
    [CARTAO]: {
      cartao: '',
      qtdParcelas: '1',
      valor: '',
      vencimento: '',
      vencimento_mask: format.date(getToday()),
      numero_documento: '',
    },
    [CHEQUE]: {
      valor: '',
      vencimento: '',
      vencimento_mask: '',
      banco: '',
      agencia: '',
      digito2: '',
      camara_compensacao: '',
      numero: '',
      tipificacao: '',
      digito1: '',
      conta: '',
      digito3: '',
      cgccpf: '',
      emitente: '',
    },
  };

  const [ativoEmEdicao, setAtivoEmEdicao] = useState(null);
  const [divisaoComissaoEmEdicao, setDivisaoComissaoEmEdicao] = useState(null);
  const [adicionandoFormaPgto, setAdicionandoFormaPgto] = useState(false);
  const [adicionandoFormaPgtoImob, setAdicionandoFormaPgtoImob] = useState(
    false
  );

  const [alterarDataVenda, setAlterarDataVenda] = useState(false);
  const [formaPagamentoEmEdicao, setFormaPagamentoEmEdicao] = useState(
    FORMA_PGTO_INICIAL
  );
  const [formaPagamentoEmEdicaoImob, setFormaPagamentoEmEdicaoImob] = useState(
    FORMA_PGTO_INICIAL
  );

  const [construtores, setConstrutores] = useState([]);
  const [construtorSelecionado, setConstrutorSelecionado] = useState(null);
  const [condicoesEspeciais, setCondicoesEspeciaisLocal] = useState(
    condicoesEspeciaisObj
  );

  const [mostrarModalCondicoes, setMostrarModalCondicoes] = useState(false);
  const [travarVendaLocal, setTravarVendaLocal] = useState({
    travarCorretor: false,
    travarGerente: false,
  });
  const [valorVendaEspecial, setValorVendaEspecial] = useState(null);
  const [vendaInterna, setVendaInternaLocal] = useState(isCorretorSetpar);
  const [tabelaPrecoValue, setTabelaPrecoValue] = useState(null);
  const [periodicidadeCorrecao, setPeriodicidadeCorrecao] = useState([
    '1',
    '2',
  ]); //WEB API -> enum PeriodicidadeCorrecao
  const [temCondicaoEspecial, setTemCondicaoEspecial] = useState(false);
  const [valoresAlcada, setValoresAlcada] = useState({
    percentual_corretor: 0,
    meses_corretor: 0,
    percentual_gerente: 0,
    meses_gerente: 0,
  });
  const [condicaoEspecialRemovida, setCondicaoEspecialRemovida] = useState(
    false
  );

  useEffect(() => {
    const valoresAlcadas = async () => {
      try {
        /**
         * @type {valoresAlcada}
         */
        const response = await api.pegarValoresAlcadas(codigoFamilia);

        setValoresAlcada(response);
      } catch (error) {
        console.error(error);
      }
    };
    valoresAlcadas();
  }, []);

  useEffect(() => {
    if (empreendimento.multiplas_comissoes && tabelaSelecionada) {
      empreendimento.tipo_recebimento_comissao =
        tabelaSelecionada.modalidade !== 3
          ? TipoComissao.RetidaCorretor
          : TipoComissao.ComissaoContrato2;
    }
  }, [tabelaSelecionada]);

  useEffect(() => {
    if (
      condicoesEspeciais &&
      condicoesEspeciais.status == CondicoesEspeciaisStatus.SemStatus
    ) {
      if (
        (condicoesEspeciais.valor_lote &&
          condicoesEspeciais.valor_lote.porcentagem_desconto >
            valoresAlcada.percentual_gerente) ||
        (condicoesEspeciais.financiamento &&
          condicoesEspeciais.financiamento.prazo_financiamento_meses >
            valoresAlcada.meses_gerente)
      ) {
        setTravarVendaLocal({
          travarCorretor: true,
          travarGerente: true,
        });
      } else if (
        (condicoesEspeciais.valor_lote &&
          condicoesEspeciais.valor_lote.porcentagem_desconto >
            valoresAlcada.percentual_corretor) ||
        (condicoesEspeciais.financiamento &&
          condicoesEspeciais.financiamento.prazo_financiamento_meses >
            valoresAlcada.meses_corretor)
      ) {
        setTravarVendaLocal({
          travarCorretor: true,
          travarGerente: false,
        });
      } else {
        setTravarVendaLocal({
          travarCorretor: false,
          travarGerente: false,
        });
      }
    }
    dispatch(setCondicoesEspeciais(condicoesEspeciais));
    setTemCondicaoEspecial(Object.values(condicoesEspeciais).length > 0);
  }, [condicoesEspeciais, valoresAlcada]);

  useEffect(() => {
    dispatch(setTravarVenda(travarVendaLocal));
  }, [travarVendaLocal]);

  useEffect(() => {
    dispatch(setVendaInterna(vendaInterna));
  }, [vendaInterna]);

  useEffect(() => {
    const buscarConstrutores = async () => {
      try {
        const response = await api.obterConstrutor();
        setConstrutores(
          response.map(c => ({ value: c.codigo, label: c.nome }))
        );
      } catch (error) {
        console.error('Erro ao buscar construtores:', error);
      }
    };

    buscarConstrutores();
  }, []);

  useEffect(() => {
    setDataVenda(getToday().format(DATE_FORMAT_SERVER));
  }, []);

  useEffect(() => {
    //reseta os formulário quando a lista é atualizada
    setAdicionandoFormaPgto(false);
    setFormaPagamentoEmEdicao(FORMA_PGTO_INICIAL);
    setAdicionandoFormaPgtoImob(false);
    setFormaPagamentoEmEdicaoImob(FORMA_PGTO_INICIAL);
  }, [listaFormasDePagamento, listaFormasDePagamentoImob]);

  useEffect(() => {
    if (!adicionandoFormaPgto) setFormaPagamentoEmEdicao(FORMA_PGTO_INICIAL);
    if (!adicionandoFormaPgtoImob)
      setFormaPagamentoEmEdicaoImob(FORMA_PGTO_INICIAL);
  }, [adicionandoFormaPgto, adicionandoFormaPgtoImob]);

  useEffect(() => {
    if (Object.keys(condicoesEspeciais).length === 0) return;

    // Base da carência: maior vencimento entre sinal e sinal mesa, igual ao servidor.
    const vencimentos = [
      ...(listaFormasDePagamento || []),
      ...(listaFormasDePagamentoImob || []),
    ]
      .map(pagamento =>
        moment.isMoment(pagamento.vencimento)
          ? moment(pagamento.vencimento)
          : moment(pagamento.vencimento, 'DD/MM/YYYY')
      )
      .filter(data => data.isValid());

    if (!vencimentos.length) return;

    const qtdMeses =
      parseInt(condicoesEspeciais.financiamento.prazo_financiamento_meses, 10) ||
      0;
    const novaData = moment
      .max(vencimentos)
      .add(qtdMeses, 'months')
      .format(DATE_FORMAT_SERVER);

    setCondicoesEspeciaisLocal({
      ...condicoesEspeciais,
      financiamento: {
        ...condicoesEspeciais.financiamento,
        data_prazo_financiamento: novaData,
      },
    });
  }, [listaFormasDePagamento, listaFormasDePagamentoImob]);
  const selecionarConstrutor = construtor => {
    if (construtor && construtor.value) {
      setConstrutorSelecionado(construtor);
      dispatch(selecionaConstrutor(construtor.value));
    }
  };

  const desabilitarFuncionalidades = () => {
    if (!readonly) {
      return false;
    }
    if (readonly && condicoesEspeciais && condicoesEspeciais.descricao == '') {
      return true;
    }
    if (
      readonly &&
      condicoesEspeciais &&
      condicoesEspeciais.status == CondicoesEspeciaisStatus.PendenteDiretoria &&
      !AuthStorage.isGerente()
    ) {
      return false;
    }
    return true;
  };
  const addPagamentoContraProposta = infosPagamento => {
    infosPagamento.forEach(pagamento => {
      adicionaFormaPgtoEntrada({
        ...pagamento,
        qtdParcelas: 1,
        vencimento: createDate(pagamento.vencimento),
      });
    });
  };

  const inserirOuAtualizarFormaPagamento = ({
    tipo_parcela,
    index,
    ...values
  }) => {
    if (values[tipo_parcela]) {
      if (index > -1) {
        atualizaFormaPgtoEntrada(
          { ...values[tipo_parcela], tipo_parcela },
          index
        );
      } else {
        adicionaFormaPgtoEntrada({
          ...values[tipo_parcela],
          tipo_parcela,
        });
      }
    }
  };

  const inserirOuAtualizarFormaPagamentoImob = ({
    tipo_parcela,
    index,
    ...values
  }) => {
    if (values[tipo_parcela]) {
      if (index > -1) {
        atualizaFormaPgtoEntradaImob(
          { ...values[tipo_parcela], tipo_parcela },
          index
        );
      } else {
        adicionaFormaPgtoEntradaImob({
          ...values[tipo_parcela],
          tipo_parcela,
        });
      }
    }
  };

  const editarFormaPagamento = (formaPagamento, index) => {
    let novoFormaPagamento = { ...FORMA_PGTO_INICIAL };

    if (
      condicoesEspeciais.status == CondicoesEspeciaisStatus.PendenteDiretoria &&
      formaPagamento.tipo_parcela === CHEQUE
    ) {
      let formPagamentoEdicao;
      if (
        formaPagamento.cheque &&
        Object.keys(formaPagamento.cheque).length > 0
      ) {
        formPagamentoEdicao = {
          valor: formaPagamento.valor,
          vencimento: formaPagamento.vencimento,
          vencimento_mask: moment(formaPagamento.vencimento).format(
            'DD/MM/YYYY'
          ),
          banco: formaPagamento.cheque.banco,
          agencia: formaPagamento.cheque.agencia,
          digito2: formaPagamento.cheque.digito2,
          camara_compensacao: formaPagamento.cheque.camara_compensacao,
          numero: formaPagamento.cheque.numero,
          tipificacao: formaPagamento.cheque.tipificacao,
          digito1: formaPagamento.cheque.digito1,
          conta: formaPagamento.cheque.conta,
          digito3: formaPagamento.cheque.digito3,
          cgccpf: formaPagamento.cheque.cgccpf,
          emitente: formaPagamento.cheque.emitente,
          tipo_parcela: formaPagamento.tipo_parcela,
        };
      } else {
        formPagamentoEdicao = {
          valor: formaPagamento.valor,
          vencimento: formaPagamento.vencimento,
          vencimento_mask: moment(formaPagamento.vencimento).format(
            'DD/MM/YYYY'
          ),
          banco: formaPagamento.banco,
          agencia: formaPagamento.agencia,
          digito2: formaPagamento.digito2,
          camara_compensacao: formaPagamento.camara_compensacao,
          numero: formaPagamento.numero,
          tipificacao: formaPagamento.tipificacao,
          digito1: formaPagamento.digito1,
          conta: formaPagamento.conta,
          digito3: formaPagamento.digito3,
          cgccpf: formaPagamento.cgccpf,
          emitente: formaPagamento.emitente,
          tipo_parcela: formaPagamento.tipo_parcela,
        };
      }
      novoFormaPagamento = {
        ...FORMA_PGTO_INICIAL,
        tipo_parcela: formaPagamento.tipo_parcela,
        [formaPagamento.tipo_parcela]: {
          qtdParcelas: 1,
          ...formPagamentoEdicao,
          vencimento_mask: formaPagamento.vencimento
            ? format.date(formaPagamento.vencimento)
            : '',
        },
        index,
      };
    } else if (
      condicoesEspeciais.status == CondicoesEspeciaisStatus.PendenteDiretoria &&
      formaPagamento.tipo_parcela === CARTAO
    ) {
      let formPagamentoEdicao;
      if (
        formaPagamento.cartao &&
        Object.keys(formaPagamento.cartao).length > 0
      ) {
        formPagamentoEdicao = {
          codigo: formaPagamento.cartao.codigo,
          descricao: formaPagamento.cartao.descricao,
          dias: formaPagamento.cartao.dias,
          numero_documento: formaPagamento.cartao.numero_documento,
          valor: formaPagamento.valor,
        };
      } else {
        formPagamentoEdicao = {
          codigo: formaPagamento.codigo,
          descricao: formaPagamento.descricao,
          dias: formaPagamento.dias,
          numero_documento: formaPagamento.numero_documento,
          valor: formaPagamento.valor,
        };
      }
      novoFormaPagamento = {
        ...FORMA_PGTO_INICIAL,
        tipo_parcela: formaPagamento.tipo_parcela,
        [formaPagamento.tipo_parcela]: {
          qtdParcelas: 1,
          ...formPagamentoEdicao,
          vencimento_mask: formaPagamento.vencimento
            ? format.date(formaPagamento.vencimento)
            : '',
        },
        index,
      };
    } else {
      novoFormaPagamento = {
        ...FORMA_PGTO_INICIAL,
        tipo_parcela: formaPagamento.tipo_parcela,
        [formaPagamento.tipo_parcela]: {
          qtdParcelas: 1,
          ...formaPagamento,
          vencimento_mask: formaPagamento.vencimento
            ? format.date(formaPagamento.vencimento)
            : '',
        },
        index,
      };
    }
    setFormaPagamentoEmEdicao(novoFormaPagamento);
    setAdicionandoFormaPgto(true);
  };

  const editarFormaPagamentoImob = (formaPagamento, index) => {
    let novoFormaPagamento = { ...FORMA_PGTO_INICIAL };

    if (
      condicoesEspeciais.status == CondicoesEspeciaisStatus.PendenteDiretoria &&
      formaPagamento.tipo_parcela === CHEQUE
    ) {
      let formPagamentoEdicao;
      if (
        formaPagamento.cheque &&
        Object.keys(formaPagamento.cheque).length > 0
      ) {
        formPagamentoEdicao = {
          valor: formaPagamento.valor,
          vencimento: formaPagamento.vencimento,
          vencimento_mask: moment(formaPagamento.vencimento).format(
            'DD/MM/YYYY'
          ),
          banco: formaPagamento.cheque.banco,
          agencia: formaPagamento.cheque.agencia,
          digito2: formaPagamento.cheque.digito2,
          camara_compensacao: formaPagamento.cheque.camara_compensacao,
          numero: formaPagamento.cheque.numero,
          tipificacao: formaPagamento.cheque.tipificacao,
          digito1: formaPagamento.cheque.digito1,
          conta: formaPagamento.cheque.conta,
          digito3: formaPagamento.cheque.digito3,
          cgccpf: formaPagamento.cheque.cgccpf,
          emitente: formaPagamento.cheque.emitente,
          tipo_parcela: formaPagamento.tipo_parcela,
        };
      } else {
        formPagamentoEdicao = {
          valor: formaPagamento.valor,
          vencimento: formaPagamento.vencimento,
          vencimento_mask: moment(formaPagamento.vencimento).format(
            'DD/MM/YYYY'
          ),
          banco: formaPagamento.banco,
          agencia: formaPagamento.agencia,
          digito2: formaPagamento.digito2,
          camara_compensacao: formaPagamento.camara_compensacao,
          numero: formaPagamento.numero,
          tipificacao: formaPagamento.tipificacao,
          digito1: formaPagamento.digito1,
          conta: formaPagamento.conta,
          digito3: formaPagamento.digito3,
          cgccpf: formaPagamento.cgccpf,
          emitente: formaPagamento.emitente,
          tipo_parcela: formaPagamento.tipo_parcela,
        };
      }
      novoFormaPagamento = {
        ...FORMA_PGTO_INICIAL,
        tipo_parcela: formaPagamento.tipo_parcela,
        [formaPagamento.tipo_parcela]: {
          qtdParcelas: 1,
          ...formPagamentoEdicao,
          vencimento_mask: formaPagamento.vencimento
            ? format.date(formaPagamento.vencimento)
            : '',
        },
        index,
      };
    } else if (
      condicoesEspeciais.status == CondicoesEspeciaisStatus.PendenteDiretoria &&
      formaPagamento.tipo_parcela === CARTAO
    ) {
      let formPagamentoEdicao;
      if (
        formaPagamento.cartao &&
        Object.keys(formaPagamento.cartao).length > 0
      ) {
        formPagamentoEdicao = {
          codigo: formaPagamento.cartao.codigo,
          descricao: formaPagamento.cartao.descricao,
          dias: formaPagamento.cartao.dias,
          numero_documento: formaPagamento.cartao.numero_documento,
          valor: formaPagamento.valor,
        };
      } else {
        formPagamentoEdicao = {
          codigo: formaPagamento.codigo,
          descricao: formaPagamento.descricao,
          dias: formaPagamento.dias,
          numero_documento: formaPagamento.numero_documento,
          valor: formaPagamento.valor,
        };
      }
      novoFormaPagamento = {
        ...FORMA_PGTO_INICIAL,
        tipo_parcela: formaPagamento.tipo_parcela,
        [formaPagamento.tipo_parcela]: {
          qtdParcelas: 1,
          ...formPagamentoEdicao,
          vencimento_mask: formaPagamento.vencimento
            ? format.date(formaPagamento.vencimento)
            : '',
        },
        index,
      };
    } else {
      novoFormaPagamento = {
        ...FORMA_PGTO_INICIAL,
        tipo_parcela: formaPagamento.tipo_parcela,
        [formaPagamento.tipo_parcela]: {
          qtdParcelas: 1,
          ...formaPagamento,
          vencimento_mask: formaPagamento.vencimento
            ? format.date(formaPagamento.vencimento)
            : '',
        },
        index,
      };
    }
    setFormaPagamentoEmEdicaoImob(novoFormaPagamento);
    setAdicionandoFormaPgtoImob(true);
  };

  const totalEntradaDCC = calcularTotalEntradaAVista(
    empreendimento.tipo_recebimento_comissao === TipoComissao.ComissaoContrato2
      ? listaFormasDePagamento
      : listaFormasDePagamentoImob
  );

  const ativosComChequeBonus = Object.values(
    ativosDaTabelaSelecionadaPorCodigo
  ).filter(
    ativo =>
      ativo.desconto &&
      (!!ativo.desconto.aplicou_cheque_bonus_sinal ||
        !!ativo.desconto.aplicou_cheque_bonus_valor_venda)
  );

  const abrirCondicoesEspeciais = () => {
    setMostrarModalCondicoes(prev => !prev);
  };

  const removerCondicoes = () => {
    setCondicoesEspeciaisLocal([]);
    setCondicaoEspecialRemovida(true);
    setTravarVendaLocal({
      travarCorretor: false,
      travarGerente: false,
    });
    const codigoChave = Object.keys(ativosDaTabelaSelecionadaPorCodigo).find(
      item => item == ativosSelecionados[0]
    );
    const itemSelecionado = ativosDaTabelaSelecionadaPorCodigo[codigoChave];

    if (itemSelecionado && itemSelecionado.codigo) {
      salvarSinal({
        ...itemSelecionado,
        valor_venda: pegarValorVendaAtivoSelecionadoOriginal(),
        desconto_valor_venda: 0,
        valor_sinal: calcularValorSinalEsperado(
          {
            tipo_entrada: itemSelecionado.tipo_entrada,
            entrada_base: itemSelecionado.entrada_base,
          },
          pegarValorVendaAtivoSelecionadoOriginal()
        ),
        valor_sinal_imobiliaria:
          ativosDaTabelaSelecionadaPorCodigo[codigoChave]
            .valor_sinal_imobiliaria_original,
        valor_sinal_incorporadora:
          ativosDaTabelaSelecionadaPorCodigo[codigoChave]
            .valor_sinal_incorporadora_original,
        codigo: itemSelecionado.codigo,
        alteracao_solicitacao_desconto: true,
      });
    }
  };

  const pegarValorVendaAtivoSelecionado = () => {
    const ativosDaTabelaSelecionados = Object.values(
      ativosDaTabelaSelecionadaPorCodigo
    ).filter(ativo => ativosSelecionados.includes(ativo.codigo));

    return ativosDaTabelaSelecionados[0].valor_venda;
  };

  useEffect(() => {
    if (tabelaSelecionada && tabelasPorCodigo[tabelaSelecionada.codigo]) {
      setTabelaPrecoValue({
        value: tabelasPorCodigo[tabelaSelecionada.codigo].codigo,
        label: tabelasPorCodigo[tabelaSelecionada.codigo].descricao,
      });
    }
  }, [tabelaSelecionada, tabelasPorCodigo]);

  const handleToggleChange = event => {
    if (tabelaPrecoValue) {
      selecionaTabela(tabelaPrecoValue.value);
    }
    setTabelaPrecoValue(null);
    if (event.target.id === 'flexRadioDefault1') {
      setPeriodicidadeCorrecao(['3']);
    } else if (event.target.id === 'flexRadioDefault2') {
      setPeriodicidadeCorrecao(['1', '2']);
    }
  };
  const pegarValorVendaAtivoSelecionadoOriginal = () => {
    const ativosDaTabelaSelecionados = Object.values(
      ativosDaTabelaSelecionadaPorCodigo
    ).filter(ativo => ativosSelecionados.includes(ativo.codigo));

    return ativosDaTabelaSelecionados[0].valor_venda_original;
  };

  const temCheque =
    empreendimento.tipo_recebimento_comissao === TipoComissao.ComissaoContrato2
      ? listaFormasDePagamento.find(p => p.tipo_parcela === CHEQUE)
      : listaFormasDePagamentoImob.find(p => p.tipo_parcela === CHEQUE);

  const exibirSinalFixo = () => {
    const codigoChave = Object.keys(ativosDaTabelaSelecionadaPorCodigo).find(
      item => item == ativosSelecionados[0]
    );
    const itemSelecionado = ativosDaTabelaSelecionadaPorCodigo[codigoChave];

    if (itemSelecionado.valor_sinal_fixo) {
      return (
        <div className="text-warning">
          <small className="d-block">
            Sinal Fixo de {formatarMonetario(itemSelecionado.valor_sinal_fixo)}
          </small>
        </div>
      );
    }
  };

  const podeExibirLabelChequeBonus = () => {
    if (!tabelaSelecionada) {
      return false;
    }

    if (
      empreendimento.tipo_recebimento_comissao ===
        TipoComissao.RetidaCorretor &&
      tabelaSelecionada &&
      tabelaSelecionada.ativos.length > 0 &&
      tabelaSelecionada.ativos[0].valor_sinal_incorporadora_original === 0
    ) {
      return false;
    }

    return true;
  };

  return (
    <Container className="mb-2">
      <Card className="border-0">
        <Card.Body className="p-2">
          <div className="d-flex justify-content-between">
            <span>Tabela de preços</span>
            {dataVenda && (
              <div className="d-flex justify-content-between">
                {isCorretorSetpar ? (
                  <div className="d-flex mr-3 align-items-center ">
                    <Form.Check
                      id="vendaInternaCheckbox"
                      type="checkbox"
                      className="d-flex"
                      checked={vendaInterna}
                      onChange={e => {
                        setVendaInternaLocal(e.target.checked);
                      }}
                    ></Form.Check>
                    <label htmlFor="vendaInternaCheckbox" className="mb-0">
                      <small>Venda sem comissão</small>
                    </label>
                  </div>
                ) : (
                  ''
                )}
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => {
                    setAlterarDataVenda(true);
                  }}
                >
                  Data venda:
                  <strong> {format.date(dataVenda)}</strong>
                </button>
              </div>
            )}
          </div>
          <div>
            <div className="container row">
              <div className="form-check mr-3">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  value={
                    periodicidadeCorrecao.includes('1') ||
                    periodicidadeCorrecao.includes('2')
                  }
                  id="flexRadioDefault2"
                  checked={
                    periodicidadeCorrecao.includes('1') ||
                    periodicidadeCorrecao.includes('2')
                  }
                  onChange={handleToggleChange}
                  disabled={readonly}
                />
                <label className="form-check-label">A Prazo</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  value={periodicidadeCorrecao.includes('3')}
                  id="flexRadioDefault1"
                  checked={periodicidadeCorrecao.includes('3')}
                  onChange={handleToggleChange}
                  disabled={readonly}
                />
                <label className="form-check-label">À Vista</label>
              </div>
            </div>
          </div>
          <small className="d-block mt-1">Selecione uma tabela</small>
          <Selector
            noOptionsMessage={() => 'Nenhuma tabela encontrada'}
            placeholder="Selecione uma tabela..."
            options={empreendimento.tabelas
              .filter(tabela =>
                periodicidadeCorrecao.includes(
                  tabela.periodicidade_correcao.toString()
                )
              )
              .map(({ codigo, descricao }) => ({
                value: codigo,
                label: descricao,
              }))}
            isDisabled={readonly}
            onChange={async option => {
              if (ativosSelecionados.length > 0) {
                const result = await dialog.confirm({
                  title: 'Trocar a tabela de preço?',
                  message:
                    'Esta ação removerá todos os ativos selecionados, bem como as parcelas de sinal e financiamentos informadas. Deseja continuar?',
                });
                if (!result.proceed) return;
              }
              setTabelaPrecoValue(option);
              selecionaTabela(option.value);
            }}
            value={tabelaPrecoValue}
            menuPortalTarget={document.body}
            menuPosition="fixed"
          />
        </Card.Body>
      </Card>
      {codigoFamilia !== EMPREENDIMENTO_LANCAMENTO &&
        codigoFamilia !== SEGUNDO_EMPREENDIMENTO_LANCAMENTO && (
          <Card className="mt-2 border-0">
            <Card.Body className="p-2">
              <div className="d-flex justify-content-between">
                <span>Indicar construtor</span>
              </div>
              <small className="d-block mt-1">Selecione um construtor</small>
              <Selector
                noOptionsMessage={() => 'Nenhum construtor encontrado'}
                placeholder="Selecione um construtor..."
                options={construtores}
                isDisabled={readonly}
                onChange={async option => {
                  if (ativosSelecionados.length > 0) {
                    const result = await dialog.confirm({
                      title: 'Trocar o construtor?',
                      message:
                        'Esta ação removerá todos os ativos selecionados. Deseja continuar?',
                    });
                    if (!result.proceed) return;
                  }
                  selecionarConstrutor(option);
                }}
                value={construtorSelecionado}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </Card.Body>
          </Card>
        )}

      <Card className="mt-2 border-0">
        <Card.Body className="p-2 ">
          <div className="d-block">
            <span>
              Selecione o{empreendimento.ativos.lenght > 1 ? 's' : ''} lote
              {empreendimento.ativos.lenght > 1 ? 's' : ''}
            </span>
            <div className="d-flex flex-column float-right">
              {empreendimento.cheque_bonus &&
                empreendimento.cheque_bonus.valor &&
                podeExibirLabelChequeBonus() && (
                  <>
                    {' '}
                    <small className="text-success">
                      Cheque Bônus de{' '}
                      {formatarMonetario(empreendimento.cheque_bonus.valor)}
                    </small>
                  </>
                )}
              {empreendimento.pasta_completa && (
                <small className="text-success text-right">
                  <strong>Pasta completa</strong>
                </small>
              )}
            </div>
          </div>

          {!tabelaSelecionada && (
            <span className="d-block text-danger">
              Selecione uma tabela para continuar
            </span>
          )}
          {tabelaSelecionada && _isEmpty(ativosSelecionados) && (
            <span className="d-block text-warning">
              Selecione um ativo para continuar
            </span>
          )}
          {empreendimento.ativos.map((item, index) => (
            <Card
              className={`${
                ativosSelecionados.includes(item.codigo)
                  ? 'border border-primary bg-white'
                  : 'bg-light text-muted'
              } my-2 `}
              key={index}
            >
              <Card.Body className="p-2 d-flex flex-column flex-sm-row align-items-center position-relative">
                <div className="d-flex justify-content-center">
                  {tabelaSelecionada && tabelaPrecoValue && !readonly && (
                    <button
                      className="btn btn-link mr-1"
                      type="button"
                      onClick={async () => {
                        if (!tabelaSelecionada) return;
                        if (
                          listaFormasDePagamento.length > 0 ||
                          listaFormasDePagamentoImob.lenght > 0 ||
                          Object.values(condicoesEspeciais || 0).length > 0
                        ) {
                          const result = await dialog.confirm({
                            title: 'Confirmar ação',
                            message:
                              'Todas as parcelas de entrada, financiamento e quaisquer condições especiais serão excluídas. Deseja continuar?',
                          });
                          if (!result.proceed) return;
                          removerCondicoes();
                        }

                        selecionaAtivo(item.codigo);
                        setValorVendaEspecial({
                          ...item,
                          ...ativosDaTabelaSelecionadaPorCodigo[item.codigo],
                        });
                      }}
                    >
                      {ativosSelecionados.includes(item.codigo) ? (
                        <IoIosRemoveCircleOutline
                          className="text-danger"
                          fontSize={24}
                        />
                      ) : (
                        <IoIosAddCircleOutline
                          className="text-success"
                          fontSize={24}
                        />
                      )}
                    </button>
                  )}
                  <div>
                    <Card.Text className="m-0">
                      <span>
                        Quadra
                        <strong> {item.quadra}</strong> / Lote
                        <strong> {item.lote}</strong> / Área
                        <strong> {item.area} m²</strong>
                      </span>
                    </Card.Text>
                    {tabelaSelecionada && tabelaPrecoValue && (
                      <div>
                        <p className="m-0">
                          Valor da venda{' '}
                          <strong>
                            {formatarMonetario(
                              ativosDaTabelaSelecionadaPorCodigo[item.codigo]
                                .valor_venda
                            )}
                          </strong>
                        </p>
                        <p className="m-0">
                          Valor do sinal{' '}
                          <strong>
                            {formatarMonetario(
                              ativosDaTabelaSelecionadaPorCodigo[item.codigo]
                                .valor_sinal
                            )}
                          </strong>
                        </p>

                        {item.codigo_solicitacao_desconto && (
                          <span>
                            Solicitação de desconto aprovado:
                            <strong>
                              # {item.codigo_solicitacao_desconto}
                            </strong>
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {ativosSelecionados.includes(item.codigo) && (
                  <div className="ml-auto d-flex flex-row flex-sm-column align-items-end">
                    <button
                      type="button"
                      className="btn btn-outline"
                      onClick={() => {
                        setAtivoEmEdicao({
                          ...item,
                          ...ativosDaTabelaSelecionadaPorCodigo[item.codigo],
                        });
                      }}
                    >
                      {readonly ? (
                        <>
                          <FaRegEye className="text-info" /> Ver Valores
                        </>
                      ) : (
                        <>
                          <FaRegEdit className="text-info" /> Editar Valores
                        </>
                      )}
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline"
                      onClick={() => {
                        setDivisaoComissaoEmEdicao({
                          codigo: item.codigo,
                          quadra: item.quadra,
                          lote: item.lote,
                          ...divisaoComissao[item.codigo],
                        });
                      }}
                    >
                      {readonly ? (
                        <>
                          <FaRegEye className="text-info" /> Ver Divisão
                          Comissão
                        </>
                      ) : (
                        <>
                          <FaRegEdit className="text-info" /> Dividir Comissão
                        </>
                      )}
                    </button>
                  </div>
                )}
                <small className="position-absolute codigo_ativo">
                  #{item.codigo}
                </small>
              </Card.Body>
            </Card>
          ))}
        </Card.Body>
      </Card>

      {!_isEmpty(ativosSelecionados) &&
        empreendimento.tipo_recebimento_comissao ===
          TipoComissao.RetidaCorretor && (
          <Card className="mt-2 border-0">
            <Card.Body className="p-2">
              <Row className="justify-content-between">
                <Col>
                  <span>Pagamento Imobiliária</span>
                </Col>
                {ativosSelecionados.length === 1 && (
                  <>
                    {!!(
                      !readonly ||
                      (readonly &&
                        condicoesEspeciais &&
                        condicoesEspeciais.descricao != '' &&
                        condicoesEspeciais.status ==
                          CondicoesEspeciaisStatus.PendenteDiretoria &&
                        !AuthStorage.isGerente())
                    ) && (
                      <div>
                        {!!(!isEmpty(condicoesEspeciais) && !readonly) && (
                          <>
                            <Button
                              type="button"
                              onClick={removerCondicoes}
                              className="btn btn-danger"
                            >
                              Remover condições
                            </Button>
                          </>
                        )}
                        {valoresAlcada.percentual_corretor > 0 &&
                          valoresAlcada.percentual_gerente > 0 && (
                            <Button
                              type="button"
                              onClick={abrirCondicoesEspeciais}
                              disabled={''}
                              className="btn btn-primary m-3"
                            >
                              {!_isEmpty(condicoesEspeciais)
                                ? 'Editar condições'
                                : 'Adicionar condições'}
                            </Button>
                          )}
                        <ModalCondicoesEspeciais
                          handleClose={() => setMostrarModalCondicoes(false)}
                          show={mostrarModalCondicoes}
                          adicionarCondicoes={setCondicoesEspeciaisLocal}
                          condicoesEspeciaisExistentes={condicoesEspeciais}
                          valorVenda={pegarValorVendaAtivoSelecionadoOriginal()}
                          valorVendaEspecial={valorVendaEspecial}
                          salvarSinal={salvarSinal}
                          valoresAlcada={valoresAlcada}
                          travarVenda={setTravarVendaLocal}
                          condicaoEspecialRemovida={condicaoEspecialRemovida}
                          setCondicaoEspecialRemovida={
                            setCondicaoEspecialRemovida
                          }
                          ativosSelecionados={ativosSelecionados}
                          ativosDaTabelaSelecionadaPorCodigo={
                            ativosDaTabelaSelecionadaPorCodigo
                          }
                          listaFormasDePagamento={listaFormasDePagamentoImob}
                          addPagamentoContraProposta={
                            addPagamentoContraProposta
                          }
                          prospecto={prospecto}
                          comissaoEmpreendimento={
                            empreendimento.tipo_recebimento_comissao
                          }
                        />
                      </div>
                    )}
                  </>
                )}
              </Row>
              <Row className="mb-2 align-items-end mt-2">
                <Col md="8">
                  <div className="d-flex flex-column">
                    {exibirSinalFixo()}
                    <div
                      className={
                        totalFaltanteEntrada > 0
                          ? 'text-warning'
                          : Number(totalTitulosSinal.toFixed(2)) >
                            Number(totalEntrada.toFixed(2))
                          ? 'text-warning'
                          : 'text-success'
                      }
                    >
                      <small className="d-block">Entrada informada</small>
                      <p className="m-0 d-flex flex-column flex-sm-row align-items-sm-center">
                        {`${formatarMonetario(
                          totalTitulosSinal,
                          false
                        )}/${formatarMonetario(totalEntrada, false)}`}
                        {totalFaltanteEntrada > 0 ? (
                          <span className="ml-2 align-items-center d-flex">
                            (faltam
                            <SendToClipboardButton
                              className="text-warning p-0"
                              valueToSend={formatarMonetario(
                                totalFaltanteEntrada
                              )}
                            >
                              {formatarMonetario(totalFaltanteEntrada)}
                            </SendToClipboardButton>
                            )
                          </span>
                        ) : Number(totalTitulosSinal.toFixed(2)) >
                          Number(totalEntrada.toFixed(2)) ? (
                          <FaTimesCircle className="ml-1" />
                        ) : (
                          <FaCheckCircle className="ml-1" />
                        )}
                      </p>
                    </div>
                    {empreendimento.sinal_minimo > 0 && (
                      <div
                        className={
                          totalEntradaDCC < empreendimento.sinal_minimo
                            ? 'text-warning'
                            : 'text-success'
                        }
                      >
                        <small className="d-block">
                          Entrada mínima
                          <Hint
                            title="Entrada mínima"
                            content={`Entrada mínima obrigatória em dinheiro ou cartão, ou de depósito e cheque com vencimento em até ${DIAS_TOLERANCIA_VENCIMENTO_CHEQUE_DEPOSITO} dias a partir da data da realização da proposta`}
                            size={12}
                          />
                        </small>
                        <p className="m-0 d-flex align-items-center">
                          {formatarMonetario(empreendimento.sinal_minimo)}
                          {totalEntradaDCC >= empreendimento.sinal_minimo && (
                            <FaCheckCircle className="ml-1" />
                          )}
                        </p>
                      </div>
                    )}
                    {ativosSelecionados.length > 1 && (
                      <div
                        className={temCheque ? 'text-success' : 'text-warning'}
                      >
                        <small className="d-block">
                          Cheque
                          <Hint
                            title="Cheque"
                            content="Vendas com mais de um lote exigem pelo menos uma parcela de entrada do tipo cheque."
                            size={12}
                          />
                          {temCheque && <FaCheckCircle className="ml-1" />}
                        </small>
                      </div>
                    )}
                  </div>
                </Col>
                {!!(
                  !readonly ||
                  (readonly &&
                    condicoesEspeciais &&
                    condicoesEspeciais.status ==
                      CondicoesEspeciaisStatus.PendenteDiretoria &&
                    !AuthStorage.isGerente())
                ) && (
                  <Col className="ml-lg-auto d-flex justify-content-end">
                    {totalTitulosSinal > 0 && (
                      <ConfirmButton
                        variant="outline-danger"
                        confirmTitle="Remover tudo?"
                        confirmText="Deseja remover todas as parcelas de sinal?"
                        onConfirm={() => removeTodasParcelasEntradaImob()}
                        className="btn-sm d-flex align-items-center text-uppercase mr-2"
                      >
                        <FaTrash className="mr-2" />
                        Limpar
                      </ConfirmButton>
                    )}
                    <button
                      type="button"
                      className="btn btn-sm btn-primary d-flex align-items-center text-uppercase"
                      onClick={() => {
                        setAdicionandoFormaPgtoImob(true);
                      }}
                    >
                      <FaPlus className="mr-2" /> Inserir
                    </button>
                  </Col>
                )}
              </Row>
              <Row>
                <Col>
                  <PerfectScrollbar style={{ maxHeight: '200px' }}>
                    <Table className="table table-striped table-sm table-bordeless">
                      <Thead>
                        <Tr>
                          <Th>Tipo</Th>
                          <Th>Vencimento</Th>
                          <Th colSpan={2}>Valor</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {listaFormasDePagamentoImob
                          .sort((a, b) => a.vencimento - b.vencimento)
                          .map((item, index) => (
                            <Tr key={index}>
                              <Td>
                                {
                                  FORMAS_PAGAMENTO_BY_CODIGO[item.tipo_parcela]
                                    .label
                                }
                              </Td>
                              <Td>{format.date(item.vencimento)}</Td>
                              <Td>{formatarMonetario(item.valor)}</Td>
                              {!desabilitarFuncionalidades() && (
                                <Td className="no-pivot">
                                  <button
                                    type="button"
                                    className="mr-2 border-0 bg-transparent text-info d-inline-flex outline-none"
                                    title="Editar"
                                    onClick={() => {
                                      editarFormaPagamentoImob(item, index);
                                    }}
                                  >
                                    <FaRegEdit className="mr-2" /> Editar
                                  </button>
                                  <button
                                    type="button"
                                    className="border-0 bg-transparent text-danger d-inline-flex"
                                    title="Remover"
                                    onClick={() =>
                                      removeFormaPgtoEntradaImob(item, index)
                                    }
                                  >
                                    <FaRegWindowClose className="mr-2" />{' '}
                                    Remover
                                  </button>
                                </Td>
                              )}
                            </Tr>
                          ))}
                      </Tbody>
                    </Table>
                  </PerfectScrollbar>
                </Col>
              </Row>
            </Card.Body>
            <Card.Body className="p-2">
              <Row className="justify-content-between">
                <Col>
                  <span>Entrada/Sinal Incorporadora</span>
                </Col>
              </Row>
              <Row className="mb-2 align-items-end mt-2">
                <Col md="8">
                  <div className="d-flex flex-column">
                    <div
                      className={
                        totalEntradaIncorporadora === 0
                          ? 'text-success'
                          : totalFaltanteEntradaIncorporadora > 0
                          ? 'text-warning'
                          : 'text-success'
                      }
                    >
                      <small className="d-block">
                        {totalTituloSinalIncorp === 0
                          ? 'Nenhuma entrada incorpordora informada'
                          : 'Entrada incorporadora informada'}
                      </small>
                      {totalEntradaIncorporadora === 0 && (
                        <>
                          {totalTituloSinalIncorp > 0 && (
                            <p className="m-0 d-flex flex-column flex-sm-row align-items-sm-center">
                              {formatarMonetario(totalTituloSinalIncorp)}
                              <FaCheckCircle className="ml-1" />
                            </p>
                          )}
                        </>
                      )}
                      {totalEntradaIncorporadora > 0 && (
                        <p className="m-0 d-flex flex-column flex-sm-row align-items-sm-center">
                          {`${formatarMonetario(
                            totalTituloSinalIncorp,
                            false
                          )}/${formatarMonetario(
                            totalEntradaIncorporadora,
                            false
                          )}`}
                          {totalFaltanteEntradaIncorporadora > 0 ? (
                            <span className="ml-2 align-items-center d-flex">
                              (faltam
                              <SendToClipboardButton
                                className="text-warning p-0"
                                valueToSend={formatarMonetario(
                                  totalFaltanteEntradaIncorporadora
                                )}
                              >
                                {formatarMonetario(
                                  totalFaltanteEntradaIncorporadora
                                )}
                              </SendToClipboardButton>
                              )
                            </span>
                          ) : Number(totalTituloSinalIncorp.toFixed(2)) >
                            Number(totalEntradaIncorporadora.toFixed(2)) ? (
                            <FaCheckCircle className="ml-1" />
                          ) : (
                            <FaCheckCircle className="ml-1" />
                          )}
                        </p>
                      )}
                    </div>
                  </div>
                </Col>
                {!!(
                  !readonly ||
                  (readonly &&
                    condicoesEspeciais &&
                    condicoesEspeciais.status ==
                      CondicoesEspeciaisStatus.PendenteDiretoria &&
                    !AuthStorage.isGerente())
                ) && (
                  <Col className="ml-lg-auto d-flex justify-content-end">
                    {totalTitulosSinal > 0 && (
                      <ConfirmButton
                        variant="outline-danger"
                        confirmTitle="Remover tudo?"
                        confirmText="Deseja remover todas as parcelas de sinal?"
                        onConfirm={() => removeTodasParcelasEntrada()}
                        className="btn-sm d-flex align-items-center text-uppercase mr-2"
                      >
                        <FaTrash className="mr-2" />
                        Limpar
                      </ConfirmButton>
                    )}
                    <button
                      type="button"
                      className="btn btn-sm btn-primary d-flex align-items-center text-uppercase"
                      onClick={() => {
                        setAdicionandoFormaPgto(true);
                      }}
                    >
                      <FaPlus className="mr-2" /> Inserir
                    </button>
                  </Col>
                )}
              </Row>
              <Row>
                <Col>
                  <PerfectScrollbar style={{ maxHeight: '200px' }}>
                    <Table className="table table-striped table-sm table-bordeless">
                      <Thead>
                        <Tr>
                          <Th>Tipo</Th>
                          <Th>Vencimento</Th>
                          <Th colSpan={2}>Valor</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {listaFormasDePagamento
                          .sort((a, b) => a.vencimento - b.vencimento)
                          .map((item, index) => (
                            <Tr key={index}>
                              <Td>
                                {
                                  FORMAS_PAGAMENTO_BY_CODIGO[item.tipo_parcela]
                                    .label
                                }
                              </Td>
                              <Td>{format.date(item.vencimento)}</Td>
                              <Td>{formatarMonetario(item.valor)}</Td>
                              {!desabilitarFuncionalidades() && (
                                <Td className="no-pivot">
                                  <button
                                    type="button"
                                    className="mr-2 border-0 bg-transparent text-info d-inline-flex outline-none"
                                    title="Editar"
                                    onClick={() => {
                                      editarFormaPagamento(item, index);
                                    }}
                                  >
                                    <FaRegEdit className="mr-2" /> Editar
                                  </button>
                                  <button
                                    type="button"
                                    className="border-0 bg-transparent text-danger d-inline-flex"
                                    title="Remover"
                                    onClick={() =>
                                      removeFormaPgtoEntrada(item, index)
                                    }
                                  >
                                    <FaRegWindowClose className="mr-2" />{' '}
                                    Remover
                                  </button>
                                </Td>
                              )}
                            </Tr>
                          ))}
                      </Tbody>
                    </Table>
                  </PerfectScrollbar>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )}

      {!_isEmpty(ativosSelecionados) &&
        empreendimento.tipo_recebimento_comissao ===
          TipoComissao.ComissaoContrato2 && (
          <Card className="mt-2 border-0">
            <Card.Body className="p-2">
              <Row className="justify-content-between">
                <Col>
                  <span>Entrada/Sinal</span>
                </Col>
                {ativosSelecionados.length === 1 && (
                  <>
                    {!!(
                      !readonly ||
                      (readonly &&
                        condicoesEspeciais &&
                        condicoesEspeciais.descricao != '' &&
                        condicoesEspeciais.status ==
                          CondicoesEspeciaisStatus.PendenteDiretoria &&
                        !AuthStorage.isGerente())
                    ) && (
                      <div>
                        {!!(!isEmpty(condicoesEspeciais) && !readonly) && (
                          <>
                            <Button
                              type="button"
                              onClick={removerCondicoes}
                              className="btn btn-danger"
                            >
                              Remover condições
                            </Button>
                          </>
                        )}
                        {valoresAlcada.percentual_corretor > 0 &&
                          valoresAlcada.percentual_gerente > 0 && (
                            <Button
                              type="button"
                              onClick={abrirCondicoesEspeciais}
                              disabled={''}
                              className="btn btn-primary m-3"
                            >
                              {!_isEmpty(condicoesEspeciais)
                                ? 'Editar condições'
                                : 'Adicionar condições'}
                            </Button>
                          )}
                        <ModalCondicoesEspeciais
                          handleClose={() => setMostrarModalCondicoes(false)}
                          show={mostrarModalCondicoes}
                          adicionarCondicoes={setCondicoesEspeciaisLocal}
                          condicoesEspeciaisExistentes={condicoesEspeciais}
                          valorVenda={pegarValorVendaAtivoSelecionadoOriginal()}
                          valorVendaEspecial={valorVendaEspecial}
                          salvarSinal={salvarSinal}
                          valoresAlcada={valoresAlcada}
                          travarVenda={setTravarVendaLocal}
                          condicaoEspecialRemovida={condicaoEspecialRemovida}
                          setCondicaoEspecialRemovida={
                            setCondicaoEspecialRemovida
                          }
                          ativosSelecionados={ativosSelecionados}
                          ativosDaTabelaSelecionadaPorCodigo={
                            ativosDaTabelaSelecionadaPorCodigo
                          }
                          listaFormasDePagamento={listaFormasDePagamento}
                          addPagamentoContraProposta={
                            addPagamentoContraProposta
                          }
                          prospecto={prospecto}
                        />
                      </div>
                    )}
                  </>
                )}
              </Row>
              <Row className="mb-2 align-items-end mt-2">
                <Col md="8">
                  <div className="d-flex flex-column">
                    <div
                      className={
                        totalFaltanteEntrada > 0
                          ? 'text-warning'
                          : 'text-success'
                      }
                    >
                      <small className="d-block">Entrada informada</small>
                      <p className="m-0 d-flex flex-column flex-sm-row align-items-sm-center">
                        {`${formatarMonetario(
                          totalTitulosSinal,
                          false
                        )}/${formatarMonetario(totalEntrada)}`}
                        {totalFaltanteEntrada > 0 ? (
                          <span className="ml-2 align-items-center d-flex">
                            (faltam
                            <SendToClipboardButton
                              className="text-warning p-0"
                              valueToSend={formatarMonetario(
                                totalFaltanteEntrada
                              )}
                            >
                              {formatarMonetario(totalFaltanteEntrada)}
                            </SendToClipboardButton>
                            )
                          </span>
                        ) : (
                          <FaCheckCircle className="ml-1" />
                        )}
                      </p>
                    </div>
                    {empreendimento.sinal_minimo > 0 && (
                      <div
                        className={
                          totalEntradaDCC < empreendimento.sinal_minimo
                            ? 'text-warning'
                            : 'text-success'
                        }
                      >
                        <small className="d-block">
                          Entrada mínima
                          <Hint
                            title="Entrada mínima"
                            content={`Entrada mínima obrigatória em dinheiro ou cartão, ou de depósito e cheque com vencimento em até ${DIAS_TOLERANCIA_VENCIMENTO_CHEQUE_DEPOSITO} dias a partir da data da realização da proposta`}
                            size={12}
                          />
                        </small>
                        <p className="m-0 d-flex align-items-center">
                          {formatarMonetario(empreendimento.sinal_minimo)}
                          {totalEntradaDCC >= empreendimento.sinal_minimo && (
                            <FaCheckCircle className="ml-1" />
                          )}
                        </p>
                      </div>
                    )}
                    {ativosSelecionados.length > 1 && (
                      <div
                        className={temCheque ? 'text-success' : 'text-warning'}
                      >
                        <small className="d-block">
                          Cheque
                          <Hint
                            title="Cheque"
                            content="Vendas com mais de um lote exigem pelo menos uma parcela de entrada do tipo cheque."
                            size={12}
                          />
                          {temCheque && <FaCheckCircle className="ml-1" />}
                        </small>
                      </div>
                    )}
                  </div>
                </Col>
                {!!(
                  !readonly ||
                  (readonly &&
                    condicoesEspeciais &&
                    condicoesEspeciais.status ==
                      CondicoesEspeciaisStatus.PendenteDiretoria &&
                    !AuthStorage.isGerente())
                ) && (
                  <Col className="ml-lg-auto d-flex justify-content-end">
                    {totalTitulosSinal > 0 && (
                      <ConfirmButton
                        variant="outline-danger"
                        confirmTitle="Remover tudo?"
                        confirmText="Deseja remover todas as parcelas de sinal?"
                        onConfirm={() => removeTodasParcelasEntrada()}
                        className="btn-sm d-flex align-items-center text-uppercase mr-2"
                      >
                        <FaTrash className="mr-2" />
                        Limpar
                      </ConfirmButton>
                    )}
                    <button
                      type="button"
                      className="btn btn-sm btn-primary d-flex align-items-center text-uppercase"
                      onClick={() => {
                        setAdicionandoFormaPgto(true);
                      }}
                    >
                      <FaPlus className="mr-2" /> Inserir
                    </button>
                  </Col>
                )}
              </Row>
              <Row>
                <Col>
                  <PerfectScrollbar style={{ maxHeight: '200px' }}>
                    <Table className="table table-striped table-sm table-bordeless">
                      <Thead>
                        <Tr>
                          <Th>Tipo</Th>
                          <Th>Vencimento</Th>
                          <Th colSpan={2}>Valor</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {listaFormasDePagamento
                          .sort((a, b) => a.vencimento - b.vencimento)
                          .map((item, index) => (
                            <Tr key={index}>
                              <Td>
                                {
                                  FORMAS_PAGAMENTO_BY_CODIGO[item.tipo_parcela]
                                    .label
                                }
                              </Td>
                              <Td>{format.date(item.vencimento)}</Td>
                              <Td>{formatarMonetario(item.valor)}</Td>
                              {!desabilitarFuncionalidades() && (
                                <Td className="no-pivot">
                                  <button
                                    type="button"
                                    className="mr-2 border-0 bg-transparent text-info d-inline-flex outline-none"
                                    title="Editar"
                                    onClick={() => {
                                      editarFormaPagamento(item, index);
                                    }}
                                  >
                                    <FaRegEdit className="mr-2" /> Editar
                                  </button>
                                  <button
                                    type="button"
                                    className="border-0 bg-transparent text-danger d-inline-flex"
                                    title="Remover"
                                    onClick={() =>
                                      removeFormaPgtoEntrada(item, index)
                                    }
                                  >
                                    <FaRegWindowClose className="mr-2" />{' '}
                                    Remover
                                  </button>
                                </Td>
                              )}
                            </Tr>
                          ))}
                      </Tbody>
                    </Table>
                  </PerfectScrollbar>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )}

      <ModalFormaPgto
        show={adicionandoFormaPgtoImob}
        onCancel={() => setAdicionandoFormaPgtoImob(false)}
        onSave={inserirOuAtualizarFormaPagamentoImob}
        initialValues={formaPagamentoEmEdicaoImob}
        cartoes={cartoes}
        isContraProposta={
          condicoesEspeciais.status ==
          CondicoesEspeciaisStatus.PendenteDiretoria
        }
      />

      <ModalFormaPgto
        show={adicionandoFormaPgto}
        onCancel={() => setAdicionandoFormaPgto(false)}
        onSave={inserirOuAtualizarFormaPagamento}
        initialValues={formaPagamentoEmEdicao}
        cartoes={cartoes}
        isContraProposta={
          condicoesEspeciais.status ==
          CondicoesEspeciaisStatus.PendenteDiretoria
        }
      />

      <ModalDataVencimento
        show={alterarDataVenda}
        onCancel={() => setAlterarDataVenda(false)}
        setDataVenda={setDataVenda}
        readonly={readonly}
        dataVenda={dataVenda}
        removeTodasParcelasEntrada={removeTodasParcelasEntrada}
        temParcelasSinal={
          empreendimento.tipo_recebimento_comissao ===
          TipoComissao.ComissaoContrato2
            ? listaFormasDePagamento.length > 0
            : listaFormasDePagamentoImob.length > 0
        }
      />

      <ModalSinal
        onCancel={() => setAtivoEmEdicao(null)}
        ativoEmEdicao={ativoEmEdicao}
        salvarSinal={salvarSinal}
        chequeBonus={empreendimento.cheque_bonus}
        ativosComChequeBonus={ativosComChequeBonus}
        readonly={readonly}
        temParcelasSinal={
          empreendimento.tipo_recebimento_comissao ===
          TipoComissao.ComissaoContrato2
            ? listaFormasDePagamento.length > 0
            : listaFormasDePagamentoImob.length > 0
        }
        valorVendaEspecial={valorVendaEspecial}
        condicoesEspeciais={condicoesEspeciais}
        comissaoEmpreendimento={empreendimento.tipo_recebimento_comissao}
        descontoMaximo={empreendimento.desconto_maximo}
      />

      <ModalDivisaoComissao
        onCancel={() => setDivisaoComissaoEmEdicao(null)}
        divisao={divisaoComissaoEmEdicao}
        salvarDivisaoComissao={salvarDivisaoComissao}
        corretores={corretores}
        readonly={readonly}
      />
    </Container>
  );
}
